import { authenticatedFetch } from "services/api";
import { WHOLSTER_REST_BASE_URL } from "services/config";

async function membershipRequest(username, sessionId, options) {
  const response = await authenticatedFetch(
    `${WHOLSTER_REST_BASE_URL}/user/${encodeURIComponent(username)}/membership`,
    sessionId,
    {
      ...options,
      headers: {
        Accept: "application/json",
        ...(options.body ? { "Content-Type": "application/json" } : {}),
        ...options.headers,
      },
    }
  );

  if (!response.ok) {
    let message = `Membership request failed with status ${response.status}.`;

    try {
      const error = await response.json();
      message = error.message || error.error || message;
    } catch (error) {
      // Preserve the status-based message for non-JSON error responses.
    }

    const requestError = new Error(message);
    requestError.status = response.status;
    throw requestError;
  }

  return response;
}

export const setProMembership = (username, sessionId) =>
  membershipRequest(username, sessionId, {
    method: "POST",
    body: JSON.stringify("pro"),
  });

export const unsetProMembership = (username, sessionId) =>
  membershipRequest(username, sessionId, { method: "DELETE" });